import { getSubCategoriesThunk } from '@redux/features/category.slice';
import { AnimatedListSkeleton, AnimatedTable, AnimatedTableBody, AnimatedTableRow } from 'components/animations';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import BreadCrumb from 'Common/BreadCrumb';
import React, { FC, useEffect, useState } from 'react';
import ButtonBase from 'components/ui/buttons/ButtonBase';
import AddSubCategoryModal from './AddSubCategoryModal';

const ProductSubCategory: FC = () => {
    const [page, setPage] = useState<number>(0);
    const [showAddModal, setShowAddModal] = useState<boolean>(false);

    const dispatch = useAppDispatch();
    const { subCategories, loading } = useAppSelector(
        (state: RootState) => (state as any).categoryState || { subCategories: [], loading: false }
    );

    const changePage = (p: number) => setPage(p);

    useEffect(() => {
        dispatch(getSubCategoriesThunk());
    }, [page, dispatch]);

    return (
        <>
            {/* <AddSubCategoryModal show={showAddModal} handleClose={() => setShowAddModal(false)} /> */}
            <BreadCrumb pageTitle={`Sub Categories List`} />
            <section className="py-5">
                <div className=" p-3 flex flex-col gap-2 bg-[#fff]">
                    <div className="flex w-full items-center justify-between">
                        <h3 className="font-extrabold text-[#bd902e]">Sub Categories List</h3>
                        {/* <ButtonBase innerText="Add Sub Category" onClick={() => setShowAddModal(true)} /> */}
                    </div>
                    {loading ? (
                        <AnimatedListSkeleton rows={8} />
                    ) : (
                        <>
                            <div>
                                <div className="overflow-x-auto">
                                    <AnimatedTable className="table-custom w-full border-separate border-spacing-y-1 whitespace-nowrap">
                                        <thead className="ltr:text-left rtl:text-right">
                                            <tr
                                                className="relative rounded-md bg-slate-50 after:absolute after:bottom-0
                    after:left-0 after:top-0 after:border-l-2
                    after:border-transparent [&.active]:after:border-custom-500"
                                            >
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">ID</th>
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">
                                                    Sub Category Name
                                                </th>
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">Category ID</th>
                                            </tr>
                                        </thead>
                                        <AnimatedTableBody loading={loading} itemCount={subCategories?.length ?? 0} animationKey={`subcat-${page}`}>
                                            {(subCategories || []).map((sc: any) => (
                                                <AnimatedTableRow
                                                    rowKey={sc?.id}
                                                    detailRecord={sc}
                                                    className="relative rounded-md bg-slate-50 after:absolute after:bottom-0
                        after:left-0 after:top-0 after:border-l-2 hover:bg-[#bd902e10]
                        after:border-transparent [&.active]:after:border-custom-500"
                                                >
                                                    <td className="px-3.5 py-2.5">{sc?.id || `-`}</td>
                                                    <td className="px-3.5 py-2.5">{sc?.categoryName || `-`}</td>
                                                    <td className="px-3.5 py-2.5">{sc?.categoryId || `-`}</td>
                                                </AnimatedTableRow>
                                            ))}
                                        </AnimatedTableBody>
                                    </AnimatedTable>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </section>
        </>
    );
};

export default ProductSubCategory;
